<template>
    <header>
        <b-navbar toggleable="lg" type="dark" fixed="top" variant="dark">
            <b-navbar-brand>
                <router-link class="navbar-brand" :to="{ name: 'Home' }">
                    RockArt
                </router-link>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item :to="'/'">Início</b-nav-item>
                    
                    <b-nav-item @click="gallery">Galeria</b-nav-item>

                    <b-nav-item :to="'/profile'">Perfil</b-nav-item>
                    
                    <b-nav-item v-if="user.role === 'Administrador'" :to="'/logs'">
                       Logs
                    </b-nav-item>

                    <b-nav-item v-if="user.role === 'Administrador'" :to="'/users'">
                        Usuários
                    </b-nav-item>
                    
                    <b-nav-item @click="help">Ajuda</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <b-modal
            size="xl"
            v-model="modalShow"
            class="text-center"
            title="Galeria"
            :ok-only="true"
            ok-title="Ok"
            style="background-color: red;"
        >
            <gallery />
        </b-modal>
    </header>
</template>

<script>
import Lockr from "lockr";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import Gallery from "./Gallery";
import Bus from "./../configs/bus";

export default {
    name: "navigation",
    components: {
        Gallery
    },
    data() {
        return {
            modalShow: false,
            options: [],
            person: null,
            addresses: [],
            addressSearch: "",
            user: Lockr.get("user")
        };
    },
    methods: {
        gallery() {
            this.modalShow = !this.modalShow;
        },

        help() {
            Swal.fire(
                "Informação Importante!",
                "Em caso de dúvidas ou sugestões, envie e-mail para rockartapp@gmail.com",
                "info"
            );
        }
    },
    mounted() {
        const vm = this;
        Bus.$on("close-modal", () => {
            vm.modalShow = false;
        });
    }
};
</script>
